import './industry-we-serve.css';
import { IIndustryComponentProps } from './interfaces/IIndustryComponentProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Industry = ({liClasses, divId, divClasses, icon, description}: IIndustryComponentProps) => {
  const liSelector: string = "#home__industries-we-serve > ul > li";

  function slideInAnimationEndHandler(e: any): void {
    const industiesListItems: NodeListOf<HTMLLIElement> = document.querySelectorAll(liSelector) as NodeListOf<HTMLLIElement>;
    
    e.target.style.left = `0px`;

    for (let i = 0; i < industiesListItems.length; i++) {
      const liElement: HTMLLIElement = industiesListItems[i];
      if (liElement.classList.contains('slide-in') === false) {
        liElement.classList.add('slide-in');
        break;
      }
    }
  }

  return <li className={liClasses?.join(' ')} onAnimationEnd={(e) => slideInAnimationEndHandler(e)}>
    <div id={divId} className={`${"circle-container"} ${divClasses?.join(' ')}`}>
      <FontAwesomeIcon icon={icon}></FontAwesomeIcon>
      <p>{description}</p>
    </div>
  </li>
}

export default Industry
